/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ElementRef, Renderer2 } from '@angular/core';
import { PulseAnimation } from './pulse-animation';

export class ShakeAnimation extends PulseAnimation {
	constructor(renderer: Renderer2, element: ElementRef) {
		super(renderer, element, 900, 'shake-animation');
	}
}
